import dataRoomApi from '../dataRoomApi';
import { DataRoomRfiRecipient } from '../models/DataRoomRfi';
import useCallbackAsync from 'hooks/useCallbackAsync';

const useRfiSendUploaderReminder = (
  rfiId: string,
  allRecipientsWithReminders: DataRoomRfiRecipient[],
  updateAllRecipientsWithReminders: (
    allRecipientsWithReminders: DataRoomRfiRecipient[],
  ) => void,
) => {
  const [onSendReminder, isLoading] = useCallbackAsync(
    async (email: string) => {
      await dataRoomApi.rfi.sendReminder(rfiId, email);

      updateAllRecipientsWithReminders(
        allRecipientsWithReminders.map((recipient) =>
          recipient.email !== email
            ? recipient
            : {
                ...recipient,
                reminders: [...recipient.reminders, new Date()],
              },
        ),
      );
    },
  );

  return { isLoading, onSendReminder };
};

export default useRfiSendUploaderReminder;
